import { denormalize } from "normalizr";

import { user } from "../../../api/schema";

export default state => {
  try {
    const items = state.users.ids;

    const denormalized = denormalize(
      { items },
      { items: [user] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
